<script>
import moment from 'moment'

import UserUtility from '@views/admin/home/admin-home.vue'
import { authService } from '@/src/services/safehaven/AuthService'
export default {
  page: {
    title: 'Operational Dashboard',
    meta: [{ name: 'description', content: 'The Operational Dashboard page.' }],
  },
  components: { UserUtility },
  data() {
    return {
      tab: null,
      items: [],
      orgName: '',
      org: '',
      column: null,
      inline: 'daily',
      noDWeek: null,
      userData: null,
      error: '',
      selectWeek: new Date(),
      nOD: moment().format('MMMM D, YYYY'),
      todayDate: moment().format('MMMM D, YYYY'),
      now: moment()
        .format('YYYY-MM-DD')
        .toString(),
      cardData: [
        {
          title: 'NUMBER OF Total Users',
          count: 208,
          desc:
            'Total # of users in your organization that have signed up for Healthbook+',
        },
        {
          title: 'ToTAL NUMBER OF User Logins',
          count: 31,
          desc: 'Total # of user logins.',
        },
        {
          title: 'AVERAGE SESSION DURATION',
          count: '3:29 min',
          desc:
            'Average amount of time all the users have spent during a login session.',
        },
        {
          title: 'HEALTH CHECK ENgagement',
          count: 12,
          desc: 'Total # of users that have taken the Health Check',
        },
        {
          title: 'MOOD CAPTURE ENGAGEMENT',
          count: 15,
          desc: 'Total # of users that have engaged with mood capture',
        },
        {
          title: 'QUESTIONNAIRE',
          count: 8,
          desc:
            'Total # of users that have engaged Health Check and also answered “bad” for mood capture.',
        },
        {
          title: 'Digital Person ENgagement',
          count: 23,
          desc: 'Total # of users that have used the digital person',
        },
        {
          title: 'Chatbot ENgagement',
          count: 19,
          desc: 'Total # of users that have used the chatbot',
        },
      ],
    }
  },
  computed: {
    getRangeSelectedText() {
      if (this.inline === 'daily')
        return this.todayDate === this.nOD ? 'Today, ' + this.nOD : this.nOD
      else return this.noDWeek
    },
  },
  watch: {
    date(val) {
      this.selectedDate = val
      this.nOD = moment(val).format(' MMMM D, YYYY')
    },
  },
  async mounted() {
    this.getOrgDetails()

    this.userData = this.$store.state.auth.currentUser
    this.orgName = this.userData.user.user_org_details[0].org_name
    this.checkUser()
  },
  methods: {
    checkUser() {
      if (!this.userData.user.is_admin && !this.userData.user.is_superadmin) {
        this.$router.push({
          name: 'safehaven-home',
        })
      }
    },
    getOrgDetails() {
      authService.getAllOrgDetails().then(
        (res) => {
          this.org = res.data
          this.org.forEach((o) => {
            if (o) {
              this.items.push(o.full_name)
            }
          })
        },
        (err) => {
          this.error = err.response
        }
      )
    },
    changeRange() {
      if (this.inline === 'daily') {
        this.nOD = moment().format('MMMM D, YYYY')
        this.selectedDate = new Date()
      } else {
        const first = new Date(
          new Date().setDate(new Date().getDate() - new Date().getDay())
        )
        const last = new Date(
          new Date().setDate(new Date().getDate() + (6 - new Date().getDay()))
        )

        this.noDWeek =
          moment(first).format('MMMM D') +
          ' - ' +
          moment(last).format('D, YYYY')
      }
    },
    nextDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D, YYYY')
      this.date = this.selectedDate
      this.setWeek(true)
    },
    previousDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(-1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D, YYYY')
      this.date = this.selectedDate
      this.setWeek(false)
    },
    setWeek(next) {
      this.selectWeek = moment(this.selectWeek)
        .add(next ? 1 : -1, 'weeks')
        .toString()

      const first = new Date(
        new Date(this.selectWeek).setDate(
          new Date(this.selectWeek).getDate() -
            new Date(this.selectWeek).getDay()
        )
      )
      const last = new Date(
        new Date(this.selectWeek).setDate(
          new Date(this.selectWeek).getDate() +
            (6 - new Date(this.selectWeek).getDay())
        )
      )

      this.noDWeek =
        moment(first).format('MMMM D') + ' - ' + moment(last).format('D, YYYY')
    },
  },
}
</script>

<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
      <v-col
        cols="12"
        sm="12"
        :md="$vuetify.breakpoint.mobile ? '12' : '10'"
        lg="10"
        xl="10"
        class="ma-auto pr-10 pl-10"
        fill-height
      >
        <div v-if="!userData.user.is_admin && userData.user.is_superadmin">
          <v-row>
            <v-col>
              <h3 class="mt-6" :class="$style.peerHeading">Dashboard</h3>

              <v-tabs
                v-model="tab"
                next-icon="mdi-arrow-right-bold-circle"
                prev-icon="mdi-arrow-left-bold-circle"
                show-arrows
                center-active
                background-color="transparent"
                :class="[
                  $style.tabClss,
                  $vuetify.breakpoint.smAndUp ? 'mt-1' : 'mt-0',
                ]"
                color="rgba(0, 0, 0, 0.87)"
              >
                <v-tab key="1"> Operational Dashboard </v-tab>
                <v-tab key="2"> Utility </v-tab>

                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-row class="mt-3">
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-select
                          v-model="orgName"
                          :items="items"
                          :placeholder="label"
                          outlined
                          hide-details="true"
                        ></v-select>
                      </v-col>
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                      >
                        &nbsp;
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        lg="3"
                        xl="3"
                        class="text-right"
                      >
                        <v-btn class="primary-btn" :class="$style.btnClss">
                          <v-icon
                            color="#fff"
                            style="background-color: transparent"
                            size="20"
                            >mdi-export</v-icon
                          >
                          Export PDF
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                        <div :class="$style.cardClss">
                          <v-row :class="$style.borderClss">
                            <v-col cols="12" sm="12" md="3" lg="4" xl="4">
                              <v-radio-group
                                v-model="inline"
                                row
                                hide-details="true"
                                @change="changeRange"
                              >
                                <v-radio label="Daily" value="daily"></v-radio>
                                <v-radio
                                  label="Weekly"
                                  value="weekly"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              :md="$vuetify.breakpoint.mdAndDown ? '8' : '5'"
                              lg="8"
                              xl="4"
                              :class="
                                $vuetify.breakpoint.mdAndDown ? '' : 'px-6'
                              "
                            >
                              <div :class="$style.carouselWrapp">
                                <v-carousel
                                  height="50"
                                  show-arrows
                                  hide-delimiters
                                >
                                  <template v-slot:prev="{ on, attrs }">
                                    <v-icon
                                      color="rgba(0, 0, 0, 0.87)"
                                      style="background-color: #fff"
                                      size="30"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="previousDate"
                                      >mdi-chevron-left</v-icon
                                    >
                                  </template>
                                  <template v-slot:next="{ on, attrs }">
                                    <v-icon
                                      color="rgba(0, 0, 0, 0.87)"
                                      style="background-color: #fff"
                                      size="30"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="nextDate"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </template>
                                  <v-carousel-item
                                    v-for="(item, i) in nOD"
                                    :key="i"
                                  >
                                    <div :class="$style.dateClss">
                                      {{ getRangeSelectedText }}
                                    </div>
                                  </v-carousel-item>
                                </v-carousel>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              v-for="card in cardData"
                              :key="card.id"
                              :class="$style.cardbox"
                              cols="12"
                              sm="12"
                              md="4"
                              lg="3"
                              xl="2"
                            >
                              <h4 :class="$style.cardTilte">{{
                                card.title
                              }}</h4>
                              <h5 :class="$style.cardCount">{{
                                card.count
                              }}</h5>
                              <p :class="$style.cardDesc">{{ card.desc }}</p>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div :class="$style.cardClss" class="mt-6">
                          <UserUtility></UserUtility>
                        </div>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-col>
          </v-row>
        </div>
        <div v-if="userData.user.is_admin && !userData.user.is_superadmin">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <h3 class="mt-6" :class="$style.peerHeading"
                >Operational Dashboard</h3
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
              <v-select
                v-model="orgName"
                :items="items"
                :placeholder="label"
                disabled
                outlined
                hide-details="true"
              ></v-select>
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.mdAndUp"
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
            >
              &nbsp;
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="text-right">
              <v-btn class="primary-btn" :class="$style.btnClss">
                <v-icon
                  color="#fff"
                  style="background-color: transparent"
                  size="20"
                  >mdi-export</v-icon
                >
                Export PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div :class="$style.cardClss">
                <v-row :class="$style.borderClss">
                  <v-col cols="12" sm="12" md="3" lg="4" xl="4">
                    <v-radio-group
                      v-model="inline"
                      row
                      hide-details="true"
                      @change="changeRange"
                    >
                      <v-radio label="Daily" value="daily"></v-radio>
                      <v-radio label="Weekly" value="weekly"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    :md="$vuetify.breakpoint.mdAndDown ? '8' : '5'"
                    lg="8"
                    xl="4"
                    :class="$vuetify.breakpoint.mdAndDown ? '' : 'px-6'"
                  >
                    <div :class="$style.carouselWrapp">
                      <v-carousel height="50" show-arrows hide-delimiters>
                        <template v-slot:prev="{ on, attrs }">
                          <v-icon
                            color="rgba(0, 0, 0, 0.87)"
                            style="background-color: #fff"
                            size="30"
                            v-bind="attrs"
                            v-on="on"
                            @click="previousDate"
                            >mdi-chevron-left</v-icon
                          >
                        </template>
                        <template v-slot:next="{ on, attrs }">
                          <v-icon
                            color="rgba(0, 0, 0, 0.87)"
                            style="background-color: #fff"
                            size="30"
                            v-bind="attrs"
                            v-on="on"
                            @click="nextDate"
                            >mdi-chevron-right</v-icon
                          >
                        </template>
                        <v-carousel-item v-for="(item, i) in nOD" :key="i">
                          <div :class="$style.dateClss">
                            {{ getRangeSelectedText }}
                          </div>
                        </v-carousel-item>
                      </v-carousel>
                    </div>
                  </v-col>
                  <v-col
                    v-if="$vuetify.breakpoint.lgAndUp"
                    cols="12"
                    sm="12"
                    md="4"
                    lg="4"
                    xl="4"
                    >&nbsp;</v-col
                  >
                </v-row>
                <v-row>
                  <v-col
                    v-for="card in cardData"
                    :key="card.id"
                    :class="$style.cardbox"
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    xl="2"
                  >
                    <h4 :class="$style.cardTilte">{{ card.title }}</h4>
                    <h5 :class="$style.cardCount">{{ card.count }}</h5>
                    <p :class="$style.cardDesc">{{ card.desc }}</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col
        v-if="!$vuetify.breakpoint.mobile"
        cols="12"
        sm="12"
        md="1"
        lg="1"
        xl="1"
      ></v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.peerHeading {
  font-size: 22px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
.cardClss {
  width: auto;
  padding: 15px 30px;
  margin: 2px;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
}
.borderClss {
  margin-bottom: 12px;
  border-bottom: 1px solid #d8d8d8;
}
.cardbox {
  padding: 12px;
}
.cardTilte {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cardCount {
  margin: 12px 0;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: #171717;
}
.cardDesc {
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #7c7c7c;
}
.carouselItem {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}
.dateClss {
  width: 250px;
  margin: 12px auto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px;
  color: #000;
  text-align: center;
}
.btnClss {
  height: auto !important;
  padding: 18px 50px !important;
  font-size: 14px;
  font-weight: 600 !important;
  line-height: 19px;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
@media screen and (max-width: 599px) {
  .btnClss {
    width: 100%;
  }
}
</style>

<style scoped>
.v-application .offwhite {
  background-color: #f2f9ff !important;
  border-color: #f2f9ff !important;
}
/deep/ .theme--light.v-icon.mdi-arrow-right-bold-circle {
  color: #0476d9 !important;
}
/deep/ .theme--light.v-icon.mdi-arrow-left-bold-circle {
  color: #0476d9 !important;
}
.v-tab {
  min-width: inherit !important;
  max-width: inherit !important;
  padding: 0;
  margin-right: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
/deep/ .v-slide-group__next--disabled {
  display: none !important;
}
/deep/ .v-slide-group__prev--disabled {
  display: none !important;
}
/deep/ .theme--light.v-tabs-items {
  background-color: transparent !important;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #0476d9 !important;
}

.v-tab--active {
  font-weight: 600 !important;
}
/deep/ .v-tabs-slider-wrapper {
  bottom: 8px !important;
}
/deep/ .theme--light.v-tabs .v-tab--active::before,
.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab:focus::before {
  opacity: 0;
}
/deep/ .theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}
/deep/ .v-ripple__container {
  display: none !important;
}

@media screen and (max-width: 959px) {
  /deep/ .v-tabs-bar {
    padding: 0 12px;
  }
}
</style>
